import { render, staticRenderFns } from "./ClickToEdit.vue?vue&type=template&id=44cb3064&"
import script from "./ClickToEdit.vue?vue&type=script&lang=js&"
export * from "./ClickToEdit.vue?vue&type=script&lang=js&"
import style0 from "./ClickToEdit.vue?vue&type=style&index=0&id=44cb3064&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports